import React from 'react'
import {Grid,Card} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { selectAlbtelecomMobileState, displayInvoiceList, displaySingleInvoice, displayMainUtilityView, resetAlbTelecomMobileSlice } from '../../../../../features/albtelecomMobile/albtelecomMobileSlice';
import {selectGlobalDataState, setGeneralMessage, setTransactionHasBeenMade} from '../../../../../features/global/globalDataSlice'
import {selectMyContractsState, resetSelectedContractInfo} from '../../../../../features/myContracts/myContractsSlice'
import smallLoadingAnimation from '../../../../../icons/lottieAnimations/smallLoading.json'
import AlbtelecomMobileInvoiceList from './AlbtelecomMobileInvoiceList'
import SingleExpandedInvoice from '../SingleExpandedInvoice'
import Lottie from "lottie-react";
import AlbtelecomMobile from './AlbtelecomMobile'
import {sendGeneralRequest} from '../../../../../features/generalRequest'
import { useLocation } from "react-router-dom";
import { selectUserInfo } from '../../../../../features/userInfo/userInfoSlice';
import MyContractsTest from '../myContracts/myContractsNew/MyContractsTest';
import { texts } from '../../../../general/texts';

const UtilityAlbtelecomMobile = (props) => {
    const albtelecomMobileSliceState = useSelector(selectAlbtelecomMobileState) 
    const globalDataSliceState = useSelector(selectGlobalDataState)
    const myContractsSliceState = useSelector(selectMyContractsState)
    const dispatch = useDispatch()
    const location = useLocation()
    const userInfo = useSelector(selectUserInfo)
    const utilityName = location.pathname.slice(location.pathname.lastIndexOf('/') + 1 , location.pathname.length)

    React.useEffect(()=>{
        albtelecomMobileSliceState.shouldDisplaySingleInvoice && dispatch(displaySingleInvoice())
        albtelecomMobileSliceState.shouldDisplayInvoiceList && dispatch(displayInvoiceList())
        albtelecomMobileSliceState.shouldDisplayMainUtilityView && dispatch(displayMainUtilityView())
        albtelecomMobileSliceState.isOfferTransactionSuccessfullyStarted && dispatch(sendGeneralRequest({request: {token: globalDataSliceState.token, phone: albtelecomMobileSliceState.phone, transID: albtelecomMobileSliceState.transactionId, offerCode: albtelecomMobileSliceState.selectedOffer }, baseUrlKey:'services', endpoint: 'Eagle/ConfirmOfferEagle'}))
        
        if(albtelecomMobileSliceState.isOfferTransactionSuccessfullyCompleted)
        {
            dispatch(setTransactionHasBeenMade(true))
            dispatch(setGeneralMessage({type: 'success', message: texts["message-success-trx"]}))
            dispatch(resetAlbTelecomMobileSlice())
        } 

        return(() => {
            dispatch(resetSelectedContractInfo())
        })
    },[albtelecomMobileSliceState.isOfferTransactionSuccessfullyStarted, albtelecomMobileSliceState.isOfferTransactionSuccessfullyCompleted, albtelecomMobileSliceState.shouldDisplaySingleInvoice, albtelecomMobileSliceState.shouldDisplayInvoiceList, albtelecomMobileSliceState.shouldDisplayMainUtilityView])

    return(
        <Grid container spacing={'2%'} pt={'3%'} >
            <Grid container item md={6.5} justifyContent={'right'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}} >
                <Card sx={{borderRadius:'20px', boxShadow:'0 0 15px 5px #E5E7EA', width:'60%', '@media (max-width: 1440px )' : {width:'70%'}, '@media (max-width: 1320px )' : {width:'90%'}}}>
                        {albtelecomMobileSliceState.shouldDisplayInvoiceList === false && albtelecomMobileSliceState.shouldDisplaySingleInvoice === false && <AlbtelecomMobile selectedContractInfo={myContractsSliceState.selectedContractInfo} utilityName={utilityName} defaultButtonStyle={props.defaultButtonStyle} selectedButtonStyle={props.selectedButtonStyle} utilityInfo={props.utilityInfo} albtelecomMobileSliceState={albtelecomMobileSliceState} globalDataSliceState={globalDataSliceState}/>}
                        {albtelecomMobileSliceState.shouldDisplayInvoiceList === true && <AlbtelecomMobileInvoiceList utilityInfo={props.utilityInfo} utilityName={utilityName} globalDataSliceState={globalDataSliceState} albtelecomMobileSliceState={albtelecomMobileSliceState}/>}  
                        {albtelecomMobileSliceState.shouldDisplaySingleInvoice === true && <SingleExpandedInvoice utilityName={utilityName} invoice={albtelecomMobileSliceState.singleInvoice} globalDataSliceState={globalDataSliceState} albtelecomMobileSliceState={albtelecomMobileSliceState}/>}  
                        <Grid container justifyContent={'center'}>
                            <Grid item md={3} xs={3}>
                                {albtelecomMobileSliceState.isLoading && <Lottie animationData={smallLoadingAnimation} loop={true} autoplay={true}/>}
                            </Grid>
                    </Grid> 
                </Card>            
            </Grid>
            <Grid container item md={4.5} justifyContent={'left'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}} > 
                <MyContractsTest utilityName={utilityName} currentLocation='utility'/>
            </Grid>
        </Grid>  
    )
}

export default UtilityAlbtelecomMobile